module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Bold.b5ab3c2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Bold.woff2
// module id = +oK5
// module chunks = 1